import { render, staticRenderFns } from "./Turnos.vue?vue&type=template&id=6415dd2f&scoped=true"
import script from "./Turnos.vue?vue&type=script&lang=js"
export * from "./Turnos.vue?vue&type=script&lang=js"
import style0 from "./Turnos.vue?vue&type=style&index=0&id=6415dd2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6415dd2f",
  null
  
)

export default component.exports